var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpray5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter0_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.25,
    cy: 10.25,
    r: 4.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter1_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 10,
    r: 3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter2_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 12.5,
    r: 2.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter3_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.45,
    cy: 14.45,
    r: 4.45
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter4_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 11,
    r: 3
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter5_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 18.5,
    r: 2.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter6_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 19.5,
    r: 3.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter7_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 23.5,
    r: 2.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter8_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 19,
    r: 3
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter9_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 20,
    r: 2
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter10_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 14.5,
    r: 2.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter11_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 4
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85,
    filter: "url(#filter12_f_54_91075)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 23,
    r: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_54_91075",
    x: 11.56,
    y: 5.56,
    width: 9.38,
    height: 9.38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_54_91075",
    x: 18.56,
    y: 6.56,
    width: 6.88,
    height: 6.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_54_91075",
    x: 15.56,
    y: 9.56,
    width: 5.88,
    height: 5.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_54_91075",
    x: 7.56,
    y: 9.56,
    width: 9.77844,
    height: 9.7799,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_54_91075",
    x: 3.56,
    y: 7.56,
    width: 6.88,
    height: 6.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_54_91075",
    x: 3.56,
    y: 15.56,
    width: 5.88,
    height: 5.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_54_91075",
    x: 8.56,
    y: 15.56,
    width: 7.88,
    height: 7.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_54_91075",
    x: 7.56,
    y: 20.56,
    width: 5.88,
    height: 5.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_54_91075",
    x: 13.56,
    y: 15.56,
    width: 6.88,
    height: 6.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_54_91075",
    x: 18.56,
    y: 17.56,
    width: 4.88,
    height: 4.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_54_91075",
    x: 19.56,
    y: 11.56,
    width: 5.88,
    height: 5.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_54_91075",
    x: 19.56,
    y: 15.56,
    width: 8.88,
    height: 8.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_54_91075",
    x: 14.56,
    y: 19.56,
    width: 6.88,
    height: 6.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.22,
    result: "effect1_foregroundBlur_54_91075"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpray5);
export default __webpack_public_path__ + "static/media/spray5.589b8be7aed2b199afa059ea452ac104.svg";
export { ForwardRef as ReactComponent };